import { render, staticRenderFns } from "./GoodsDetail2.vue?vue&type=template&id=06d9b93d&scoped=true&"
import script from "./GoodsDetail2.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetail2.vue?vue&type=style&index=0&id=06d9b93d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9b93d",
  null
  
)

export default component.exports